export type RelationshipTier = 'strong' | 'medium' | 'weak';

/**
 * Opacity for a relationship link given its backend-derived tier.
 * Falls back to a confidence-scaled opacity when tier is absent (older data).
 */
export function tierOpacity(tier: RelationshipTier | undefined, confidence: number | undefined): number {
  switch (tier) {
    case 'strong':
      return 1;
    case 'medium':
      return 0.7;
    case 'weak':
      return 0.35;
    default:
      return Math.min(1, Math.max(0.3, confidence ?? 0.5));
  }
}
